module.exports = __webpack_public_path__ + "img/img3.43011a7b.png";